import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    selectedType: { type: "Date Wise" },
    selectedAccount: null,
    fromDate: null,
    toDate: null,
    rawFrom: null,
    rawTo: null,
  },
  list: [],
  loading: false,
  balanceTotal: 0,
  searchResults: [],
  loadingSearch: false,
};

const expenseBalanceSlice = createSlice({
  name: 'expenseBalance',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setReportData: (state, action) => {
      state.list = action.payload.expenses || [];
      state.balanceTotal = action.payload.total_balance || 0;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingSearch: (state, action) => {
      state.loadingSearch = action.payload;
    },
    resetState: () => initialState,
  },
});

export const { setFilters, setReportData, setSearchResults, setLoading, setLoadingSearch, resetState } = expenseBalanceSlice.actions;
export default expenseBalanceSlice.reducer;